import { Injectable } from '@angular/core';
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  isWebPlattform = false;

  constructor() {
    Device.getInfo().then(
      (deviceInfo) => (this.isWebPlattform = deviceInfo.platform === 'web')
    );
  }
}
